import React, { useEffect, useState } from 'react';
import axios from 'axios';
import bookmark_icon from '../assets/images/bookmark_icon.svg';
import config from '../config/config';

const Bookmarks = ({ sortOption, handleFilterChange }) => {
  const [bookmarks, setBookmarks] = useState([]);
  const [bookmarkCount, setBookmarkCount] = useState(0);

  useEffect(() => {
    // Fetch bookmarks from API
    const fetchBookmarks = async () => {
      try {
        const token = localStorage.getItem('token'); // Assuming the token is stored in localStorage

        const response = await axios.get(`${config.baseURL}/get-bookmarks`, {
          headers: {
            Authorization: `Bearer ${token}` // Add the token in the Authorization header
          }
        });

        const data = response.data;

        // Check if the response is successful and has posts
        if (data.success && Array.isArray(data.posts)) {
          setBookmarks(data.posts);
          setBookmarkCount(data.posts.length);
        } else {
          setBookmarks([]);
          setBookmarkCount(0);
        }
      } catch (error) {
        console.error('Error fetching bookmarks:', error);
      }
    };

    fetchBookmarks();
  }, []);

  return (
    <div>
      <div className="post_top_section_head collection_tabs_content">
        <div className="title_post_head">RECENT</div>        
      </div>

      {bookmarkCount === 0 ? (
        <div className="no_bookmarg_block">
          <div className="no_bookmarg_content">
            <img src={bookmark_icon} alt="Bookmark icon" />
            No bookmarks yet
          </div>
        </div>
      ) : (
        <div className="bookmark_list">
          <ul>
          <li>
            <a href="#" className="bookmark_list_block">
              <div className="bookmark_list_block_left">
                <span className="title_bookmark"> All bookmarks </span>
                <span className="bookmark_count">{bookmarkCount} Posts</span>
              </div>
              <div className="bookmark_list_block_right">
                <ul>
                    {bookmarks.map((bookmark, index) => (
                      <li key={index}>
                        {bookmark.media.map((mediaItem, mediaIndex) => {
                          if (mediaItem.file_type === 'video') {
                            return (
                              <video
                                key={mediaIndex}
                                controls
                                src={mediaItem.url}
                                alt={`Bookmark ${index} - Video ${mediaIndex}`}
                              />
                            );
                          } else if (mediaItem.file_type === 'image') {
                            return (
                              <img
                                key={mediaIndex}
                                src={mediaItem.url}
                                alt={`Bookmark ${index} - Image ${mediaIndex}`}
                              />
                            );
                          } else {
                            return null; // If it's neither video nor image, render nothing
                          }
                        })}
                      </li>
                    ))}
                  </ul>
              </div>
            </a>
          </li>
          </ul>
        </div>
      )}
    </div>
  );
};

export default Bookmarks;
